import type { CampaignScheduleField } from './types';

export const CAMPAIGN_SCHEDULE_FIELDS: Array<CampaignScheduleField> = [];
